import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { WaiversPoliciesApi, type SearchQueryRequest } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface UsePoliciesSearchGetProps {
  page?: number;
  pageSize?: number;
  searchQueryRequest?: SearchQueryRequest | null;
  enabled?: boolean;
}

export const usePoliciesSearchGet = ({
  page = 1,
  pageSize = 40,
  searchQueryRequest,
  enabled = true,
}: UsePoliciesSearchGetProps = {}) => {
  const accessToken = useAccessToken();

  const { data, isPending, isFetching, isError, isSuccess, refetch } =
    useQuery({
      queryKey: [
        QueryKeys.Waivers,
        "search",
        page,
        pageSize,
        searchQueryRequest,
      ],
      queryFn: async () => {
        const service = createAuthenticatedApi(WaiversPoliciesApi, accessToken!);
        return service.apiPoliciesSearchPost({
          page,
          pageSize,
          searchQueryRequest: searchQueryRequest ?? undefined,
        });
      },
      enabled: !!accessToken && enabled,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      throwOnError: false,
    });

  return { data, isPending, isFetching, isError, isSuccess, refetch };
};
